export const dangerousGoods = [
  {
    class: "1",
    title: "Dangerous Goods kelas 1: Explosive (Bahan peledak)",
    description:
      "Barang ini berpotensi untuk meledak akibat reaksi kimia atau fisik yang tidak terkendali.",
    items: ["Kembang api", "Flare", "Detonator", "Amunisi"]
  },
  {
    class: "2",
    title: "Dangerous Goods kelas 2: Flammable Gas/Gases (Berbahan gas)",
    description:
      "Barang ini dapat membahayakan karena sifatnya yang mudah terbakar, beracun, korosif, bahkan menyebabkan ledakan.",
    items: [
      "Propana",
      "Butana",
      "Nitrogen",
      "Helium",
      "Argon",
      "Amonia",
      "Klorin",
      "Karbon Monoksida"
    ]
  },
  {
    class: "3",
    title: "Dangerous Goods kelas 3: Flammable Liquid (Cairan mudah terbakar)",
    description:
      "Barang ini mencakup cairan yang mudah terbakar di suhu tertentu jika terkena sumber panas, percikan api atau nyala api.",
    items: [
      "Aseton/minyak aseton",
      "Perekat",
      "Cat/Pernis",
      "Alkohol",
      "Bio-bahan bakar cair",
      "Produk wewangian",
      "Bensin",
      "Solar",
      "Avtur"
    ]
  },
  {
    class: "4",
    title: "Dangerous Goods kelas 4: Flammable Solid (Padatan yang mudah terbakar)",
    description:
      "Barang ini mencakup bahan padat yang mudah terbakar, serta bahan yang bereaksi secara spontan atau melepaskan gas mudah terbakar saat kontak dengan air.",
    items: [
      "Korek api",
      "Belerang",
      "Fosfor",
      "Natrium",
      "Kalsium Karbida",
      "Magnesium",
      "Serbuk logam"
    ]
  },
  {
    class: "5",
    title: "Dangerous Goods kelas 5: Oxidizer (Oksidator dan peroksida organik)",
    description:
      "Barang ini bisa mempercepat proses pembakaran, menyebabkan ledakan, dan memicu kebakaran jika terkena bahan mudah terbakar.",
    items: [
      "Amonium nitrat (Pupuk & Bahan Peledak)",
      "Kalium nitrat",
      "Amonium nitrat",
      "Benzoyl peroxide"
    ]
  },
  {
    class: "6",
    title: "Dangerous Goods kelas 6: Toxic (Bahan beracun)",
    description:
      "Barang ini dapat membahayakan kesehatan manusia, hewan, atau lingkungan jika terpapar secara langsung/tidak langsung.",
    items: [
      "Sianida",
      "Arsenik",
      "Merkuri",
      "Virus Ebola",
      "Sampel darah yang terkontaminasi"
    ]
  },
  {
    class: "7",
    title: "Dangerous Goods kelas 7: Radioactive material (Bahan radioaktif)",
    description:
      "Barang ini memancarkan radiasi ionisasi yang membahayakan kesehatan manusia, hewan, dan lingkungan jika tidak ditangani dengan benar.",
    items: [
      "Uranium-235",
      "Plutonium",
      "Cesium-137",
      "Bahan penelitian (Isotop di lab/reaktor nuklir)",
      "Bahan Industri (NDT, alat ukur)",
      "Peralatan medis: sumber radiografi, kobalt-60 untuk terapi kanker"
    ]
  },
  {
    class: "8",
    title: "Dangerous Goods kelas 8: Corrosives (Bahan korosif)",
    description:
      "Zat ini menyebabkan kerusakan serius pada jaringan hidup (kulit, mata, atau saluran pernapasan) atau merusak material lain.",
    items: [
      "Asam sulfat",
      "Asam nitrat",
      "Asam hidroklorida",
      "Fenol",
      "Baterai berisi elektrolit asam/alkali",
      "Cairan penghilang karat"
    ]
  },
  {
    class: "9",
    title: "Dangerous Goods kelas 9: Miscellaneous (Bahan berbahaya)",
    description:
      "Barang ini mencakup berbagai bahan & benda dengan risiko bahaya selama di transportasi, tetapi tidak termasuk dalam kelas 1 hingga 8.",
    items: ["Battery Lithium", "Metal", "Bahan magnet"]
  }
]
